import Nullstack from 'nullstack';
export default function IconArrowGuide({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-arrow-guide",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "5",
    cy: "19",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M7 19h3a2 2 0 0 0 2 -2v-8a2 2 0 0 1 2 -2h7"
  }), "   ", Nullstack.element("path", {
    d: "M18 4l3 3l-3 3"
  }), " ");
}